import React from 'react';

import cx from 'classnames';

import type { RailEntryViewModel } from '../../viewmodels/createSectionsRailViewModel';

import styles from './SectionsRail.scss';

type Props = {
  viewModel: RailEntryViewModel;
};

export function SectionsRailEntry({ viewModel }: Props) {
  return (
    <li className={cx(styles.entry, viewModel.isHidden && styles.hidden)}>
      {viewModel.name}
    </li>
  );
}
